import { useLazyQuery } from '@apollo/client'
import { GET_USER } from '../graphql/queries'

const useAccount = (authState) =>
  useLazyQuery(GET_USER, { variables: { id: authState?.user?.uid } })

export default useAccount
